// extracted by mini-css-extract-plugin
export default {"list":"storm_list__mH8vT"};